import { Component, OnInit, AfterContentInit, ViewChild } from '@angular/core';
import { AdmissionWizardService, AdmissionAdmitedWizardService } from 'src/app/services/wizard/admission/admission.wizzard.service';
import { MatTabGroup } from '@angular/material';
import { MenuService } from 'src/app/services/menu.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-scanner-edit-component',
  templateUrl: './scanner-edit.component.html'
})
export class ScannerEditComponent implements OnInit {

  @ViewChild('tabGroup', {static: false}) tabGroup: MatTabGroup;
  loadingAction: boolean;
  loading: boolean;
  form: FormGroup;

  constructor( private menuService: MenuService
    , private notificationToastService: NotificationToastService
    , private userService: UserService
    , private router: Router
    , private formBuilder: FormBuilder
    , private route: ActivatedRoute) {
        this.form = this.formBuilder.group({
          Ip: ['', Validators.required]
          , Name: ['', Validators.required]
          , Id: ['']
          , ExecuteCommand: [false]
        });
  }

  get f() { return this.form.controls; }

  cancel(): void {
    this.router.navigate(['scanner-search']);
  }

  async save() {
    try {
      if (this.form.valid) {
        this.loadingAction = true;
        await this.userService.scannerUpdate(this.form.getRawValue());
        this.router.navigate(['scanner-search']);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Escaner');
    } finally {
      this.loadingAction = false;
    }
  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      try {
        this.loading = true;
        const id = params['Id'];
        if (id) {
          const scanner = await this.userService.getScannerById(id);
          this.form.patchValue({
            Ip: scanner.Ip
            , Name: scanner.Name
            , Id: scanner.Id
            , ExecuteCommand: scanner.ExecuteCommand
          });
        }
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Escaner');
      } finally {
        this.loading = false;
      }
    });
  }
}
